import {Permissions} from 'auth/PermissionConstants';
import {PlateSchemaType} from 'samples/storables/StorableSchemaConstants';

export function getInformationForMoveStorablesAction(
  storables: Array<{permissions: Permissions; parentStorableId?: string | null}>,
  plateTypeById: {[id: string]: PlateSchemaType}
): {
  someStorablesAreSpecified: boolean;
  allStorablesAreWritable: boolean;
  noFixedPlateWellsSpecified: boolean;
} {
  const someStorablesAreSpecified = storables.length > 0;
  const allStorablesAreWritable = storables.every((storable) => storable.permissions.writable);
  const noFixedPlateWellsSpecified = storables.every(
    ({parentStorableId}) =>
      parentStorableId == null || plateTypeById[parentStorableId] !== PlateSchemaType.FIXED_PLATE
  );
  return {someStorablesAreSpecified, allStorablesAreWritable, noFixedPlateWellsSpecified};
}

export function getMoveStorablesTooltip(
  someStorablesAreSpecified: boolean,
  allStorablesAreWritable: boolean,
  noFixedPlateWellsSpecified: boolean,
  customTooltipText?: string
): string {
  if (customTooltipText != null) {
    return customTooltipText;
  }
  if (!someStorablesAreSpecified) {
    return 'Select inventory items to move';
  }
  if (!noFixedPlateWellsSpecified) {
    return 'Well plate wells cannot be moved';
  }
  if (!allStorablesAreWritable) {
    return "You don't have permission to move some of the selected items";
  }
  return 'Move to location';
}

export function shouldDisableMoveStorablesAction(
  someStorablesAreSpecified: boolean,
  allStorablesAreWritable: boolean,
  noFixedPlateWellsSpecified: boolean
): boolean {
  return !(someStorablesAreSpecified && allStorablesAreWritable && noFixedPlateWellsSpecified);
}
